<template>
  <div>
    <div id="votefriend" class="votefriend">
      <div class="menubar clearfix">
        <div class="logo">
          <img src="./images/Peopleplus_Logo-01.png">
        </div>
        <div class="right-section" v-show="pcDisp">
          <div class="menu">
            <!-- <a href="#home" ref="menu1" @click="toggleClickMenu('1')"><span>{{ labels[app.nowLang]['VOTEFRIEND'][1] }}</span></a> -->
            <router-link :to="{ name: 'home' }"><span>{{ labels[app.nowLang]['VOTEFRIEND'][1] }}</span></router-link>
            <a href="#vote" ref="menu2" @click="toggleClickMenu('2')"><span>{{ labels[app.nowLang]['VOTEFRIEND'][2] }}</span></a>
            <a href="#rule" ref="menu3" @click="toggleClickMenu('3')"><span>{{ labels[app.nowLang]['VOTEFRIEND'][3] }}</span></a>
          </div>
          <div class="profile-img">
            <img v-if="profile.namimage" :src="profile.namimage">
            <img v-if="!profile.namimage" src="../../assets/img/no_image.png">
          </div>
        </div>
        <div class="right-section-mb" v-show="!pcDisp">
          <div class="menu-mb" @click="toggleMenu">
            <div class="rec"></div>
            <div class="rec"></div>
            <div class="rec"></div>
          </div>
        </div>
        <div class="menu-list clearfix" :class="[ menuDisp ? 'animated slideInRight' : 'animated slideOutRight' ]" v-show="menuDisp">
          <div class="close-icon clearfix" @click="toggleMenu"><i class="fa fa-times" aria-hidden="true"></i></div>
          <div class="profile-img clearfix">
            <img v-if="profile.namimage" :src="profile.namimage">
            <img v-if="!profile.namimage" src="../../assets/img/no_image.png">
          </div>
          <!-- <a class="list" href="#home" ref="menu1" @click="toggleClickMenu('1')"><span>{{ labels[app.nowLang]['VOTEFRIEND'][1] }}</span></a> -->
          <router-link class="list" :to="{ name: 'home' }"><span>{{ labels[app.nowLang]['VOTEFRIEND'][1] }}</span></router-link>
          <a class="list" href="#vote" ref="menu2" @click="toggleClickMenu('2')"><span>{{ labels[app.nowLang]['VOTEFRIEND'][2] }}</span></a>
          <a class="list" href="#rule" ref="menu3" @click="toggleClickMenu('3')"><span>{{ labels[app.nowLang]['VOTEFRIEND'][3] }}</span></a>
        </div>
      </div>
      <a id="home"></a>
      <div class="header clearfix" v-parallax="-0.1">
        <div class="col-sm-2 clear-padding"></div>
        <div class="col-xs-12 col-sm-8 campaign-text" v-parallax="0.1">
          <div class="campaign-name">{{ labels[app.nowLang]['VOTEFRIEND'][4] }}</div>
          <div class="taglines">{{ labels[app.nowLang]['VOTEFRIEND'][5] }}</div>
        </div>
        <div class="col-xs-12 col-sm-2 season-icon">
          <img src="./images/label.png">
        </div>
      </div>

      <a id="vote"></a>
      <div class="content" v-parallax="-0.1">
        <div class="topic-box">
          <div class="topic">
            <div class="row">
              <div class="col-xs-2 col-sm-4 clear-padding"></div>
              <div class="col-xs-8 col-sm-4 text1 clear-padding">{{ labels[app.nowLang]['VOTEFRIEND'][6] }}</div>
              <div class="col-xs-2 col-sm-4 clear-padding"><img class="heart" src="./images/icon_heart.png"></div>
            </div>
            <div class="row">
              <div class="col-xs-2 col-sm-4 clear-padding"></div>
              <div class="col-xs-8 col-sm-4 text2 clear-padding">{{ labels[app.nowLang]['VOTEFRIEND'][7] }}</div>
              <div class="col-xs-2 col-sm-4 clear-padding"></div>
            </div>
          </div>
        </div>

        <vote-friend-list 
          :labels="labels[app.nowLang]"
          :nowLang="app.nowLang"
          :friendLists="friendLists"
          :pcDisp="pcDisp" 
          :pageCurrent="pageCurrent"
          :maxPage="maxPage"
          :numberPerPage="numberPerPage"
          :setPageCurrent="setPageCurrent"
          :setMaxPage="setMaxPage"
          :togglePopup="togglePopup" />

        <a id="rule"></a>
        <div class="rule-box clearfix">
          <div class="topic">{{ labels[app.nowLang]['VOTEFRIEND'][11] }}</div>
          <div class="detail">{{ labels[app.nowLang]['VOTEFRIEND'][12] }}</div>
          <div class="col-xs-12">
            <div class="col-sm-4 clear-padding">
              <img class="hand" src="./images/image_content.png">
            </div>
            <div class="col-sm-6 clear-padding">
              <div class="how-to">{{ labels[app.nowLang]['VOTEFRIEND'][13] }}</div>
              <div class="list-group">
                <i class="icon fa fa-star" aria-hidden="true"></i>
                <span class="rule-list">{{ labels[app.nowLang]['VOTEFRIEND'][14] }}</span>
              </div>
              <div class="list-group">
                <i class="icon fa fa-star" aria-hidden="true"></i>
                <span class="rule-list">{{ labels[app.nowLang]['VOTEFRIEND'][15] }}</span>
              </div>
              <div class="list-group">
                <i class="icon fa fa-star" aria-hidden="true"></i>
                <span class="rule-list">{{ labels[app.nowLang]['VOTEFRIEND'][16] }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="score-box clearfix">
          <div class="col-xs-12 clearfix">
            <img class="score-icon" src="./images/icon_star.png">
            <div class="topic">{{ labels[app.nowLang]['VOTEFRIEND'][17] }}</div>
          </div>

          <div class="score-row clearfix">
            <div class="col-sm-4">
              <div class="title">{{ labels[app.nowLang]['VOTEFRIEND'][18] }}</div>
              <div class="detail">{{ labels[app.nowLang]['VOTEFRIEND'][19] }}</div>
            </div>
            <div class="col-sm-4">
              <div class="title">{{ labels[app.nowLang]['VOTEFRIEND'][20] }}</div>
              <div class="detail">{{ labels[app.nowLang]['VOTEFRIEND'][21] }}</div>
            </div>
            <div class="col-sm-4">
              <div class="title">{{ labels[app.nowLang]['VOTEFRIEND'][22] }}</div>
              <div class="detail">{{ labels[app.nowLang]['VOTEFRIEND'][23] }}</div>
            </div>
          </div>

          <div class="score-row clearfix">
            <div class="col-sm-2">
            </div>
            <div class="col-sm-4">
              <div class="title">{{ labels[app.nowLang]['VOTEFRIEND'][24] }}</div>
              <div class="detail">{{ labels[app.nowLang]['VOTEFRIEND'][25] }}</div>
            </div>
            <div class="col-sm-4">
              <div class="title">{{ labels[app.nowLang]['VOTEFRIEND'][26] }}</div>
              <div class="detail">{{ labels[app.nowLang]['VOTEFRIEND'][27] }}</div>
            </div>
            <div class="col-sm-2">
            </div>
          </div>
        </div>

        <div class="annoucement-box clearfix">
          <div class="announce-icon">
            <img class="score-icon" src="./images/icon_megaphone.png">
          </div>
          <div class="topic">{{ labels[app.nowLang]['VOTEFRIEND'][28] }}</div>
          <div class="detail">{{ labels[app.nowLang]['VOTEFRIEND'][29] }} {{ quarterly }}
            {{ labels[app.nowLang]['VOTEFRIEND'][30] }}</div>

          <div class="topic2">
            <img class="prize-icon" src="./images/icon_reward.png">
            {{ labels[app.nowLang]['VOTEFRIEND'][31] }}
          </div>
          <div class="detail">{{ labels[app.nowLang]['VOTEFRIEND'][32] }}</div>
          <div class="detail">{{ labels[app.nowLang]['VOTEFRIEND'][33] }}</div>
        </div>
      </div>

      <div class="footer">
        <div class="col-xs-12 copy">Copyright 2017 People Plus Software Co., Ltd. All Rights Reserved.</div>
      </div>
    </div>
    <popup  :labels="labels[app.nowLang]"
            :popup="popup"
            :postVotefriendSave="postVotefriendSave"
            :currentCodempid="codempid"
            :pcDisp="pcDisp" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/votefriend/mutation-types'
import voteFriendList from 'components/votefriend/voteFriendList'
import popup from 'components/votefriend/popup'
import moment from 'moment'

export default {
  name: 'votefriend',
  data () {
    return {
      app: this.$parent,
      menuDisp: false,
      toggleClick: {
        1: false,
        2: false,
        3: false
      }
    }
  },
  created () {
    this.receivedVotefriendLabels()
    this.receivedVotefriendIndex()
    this.receivedVotefriendProfile()
  },
  computed: {
    pcDisp () {
      return this.app.pcDisp
    },
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    quarterly () {
      let intNum = (parseInt(moment().format('M') / 3) + (parseInt(moment().format('M') % 3) > 0 ? 1 : 0))
      return intNum + ' (' + moment((intNum * 3 - 2), 'M', this.app.nowLang).format('MMM') + ' - ' + moment(intNum * 3, 'M', this.app.nowLang).format('MMM') + ' ' + (parseInt(moment().format('Y')) + 543) + ')'
    },
    ...mapGetters({
      labels: types.GET_VOTEFRIEND_LABELS,
      profile: types.GET_VOTEFRIEND_PROFILE,
      friendLists: types.GET_VOTEFRIEND_INDEX,
      pageCurrent: types.GET_VOTEFRIEND_PAGECURRENT,
      maxPage: types.GET_VOTEFRIEND_MAXPAGE,
      numberPerPage: types.GET_VOTEFRIEND_NUMPERPAGE,
      popup: types.GET_VOTEFRIEND_INDEX_SELECTED
    })
  },
  methods: {
    toggleClickMenu (index) {
      if (!this.toggleClick[index]) {
        this.toggleClick[index] = true
        this.$refs['menu' + index].click()
      } else {
        this.toggleClick[index] = false
      }
    },
    toggleMenu () {
      this.menuDisp = !this.menuDisp
    },
    togglePopup (params) {
      this.setIndexSelected(params)
    },
    ...mapMutations({
      setIndexSelected: types.SET_VOTEFRIEND_INDEX_SELECTED,
      setPageCurrent: types.SET_VOTEFRIEND_PAGECURRENT,
      setMaxPage: types.SET_VOTEFRIEND_MAXPAGE
    }),
    ...mapActions({
      receivedVotefriendLabels: types.RECEIVED_VOTEFRIEND_LABELS,
      receivedVotefriendProfile: types.RECEIVED_VOTEFRIEND_PROFILE,
      receivedVotefriendIndex: types.RECEIVED_VOTEFRIEND_INDEX,
      postVotefriendSave: types.POST_VOTEFRIEND_SAVE
    })
  },
  components: {
    voteFriendList,
    popup
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// component.vue?f3b66618